import { SendStickerParam } from '@@types/Api/Sticker';
import { StickerLog } from '@@types/Log';
import Sticker from '@@types/Sticker';

import { URLS } from '~/constants';
import { LOG_SEND_TIMEOUT } from '~/constants/api';
import Api2 from '~/stores/providers/Api2';

class StickerApi {
  constructor(private api: Api2) {}

  fetchSticker = (): Promise<Sticker[]> => {
    return this.api.contentsRequester.get(`${URLS.API}/stickers`);
  };

  sendSticker = ({ channelId, text, token }: SendStickerParam): Promise<StickerLog> => {
    return this.api.contentsRequester.post(
      `${URLS.API}/stickers/${channelId}`,
      { text, token },
      { timeout: LOG_SEND_TIMEOUT }
    );
  };
}

export default StickerApi;
